export default "__VITE_ASSET__CxgBQVQy__"